export const SUCCESS = '/backoffice/user/SUCCESS';
export const REQUEST = '/backoffice/user/REQUEST';
export const ERROR = '/backoffice/user/ERROR';


// WEBPACK FOOTER //
// ./src/store/user/types.js